import React from 'react';
import { createBrowserRouter } from 'react-router-dom';


//****************************HOMELAYOUT && PAGES - PUBLIC
// import HomeLayout from '../layout/HomeLayout'
// import Main from '../pages/HomePages/Main/MainPages'
// import Contact from '../pages/HomePages/Contact/Contact'


//****************************ERRORLAYOUT && PAGES - PUBLIC
import ErrorLayout from '../layout/ErrorLayout'
import Page404 from '../pages/ErrorPages/Page404'

//****************************AUTHLAYOUT && PAGES - PUBLIC
import AuthLayout from '../layout/AuthLayout'
import Login from '../pages/AuthPages/Login/Login'
import RegisterControl from '../pages/AuthPages/Register/RegisterControl';
import RegisterSave from '../pages/AuthPages/Register/RegisterSave';
import ForgetPassword from '../pages/AuthPages/ForgetPassword'

//****************************ADMINLAYOUT && PAGES - PRIVATE
import AdminLayout from '../layout/AdminLayout'
import Dashboard from '../pages/AdminPages/Dashboard/Dashboard';

//Yönetici
import DonemIslemleri from '../pages/AdminPages/Yonetici/DonemIslemleri';
import OgrenciListesi from '../pages/AdminPages/Yonetici/OgrenciListesi';
import Tanimlar from '../pages/AdminPages/Yonetici/Tanimlar';
import DanismanTanimlari from '../pages/AdminPages/Yonetici/DanismanTanimlari';
import TumBasvurular from '../pages/AdminPages/Yonetici/TumBasvurular';
import SistemAyarlari from '../pages/AdminPages/Yonetici/SistemAyarlari';

//Öğrenci
import OgrenciHesap from '../pages/AdminPages/Ogrenci/OgrenciHesap';
import YeniBasvuru from '../pages/AdminPages/Ogrenci/YeniBasvuru';
import SeminerPrint from '../pages/AdminPages/Ogrenci/SeminerPrint';
import OgrenciBasvurular from '../pages/AdminPages/Ogrenci/OgrenciBasvurular';

//Danışman
import Basvurular from '../pages/AdminPages/Danisman/Basvurular';


import RoleRoute from './RoleRoute';

import useAuth from './useAuth';




const router = createBrowserRouter([

    {
        path: '/',
        element: <AuthLayout />,
        children: [
            { path: '/', element: <Login /> },
            { path: 'login', element: <Login /> },
            { path: 'register', element: <RegisterControl /> },
            { path: 'register-control', element: <RegisterSave /> },
            { path: 'forget-password', element: <ForgetPassword /> }
        ],
    },
    {
        element: <AdminLayout />,
        children: [
            { path: 'dashboard', loader : useAuth, element: <RoleRoute roles={["Yönetici","Danışman","Öğrenci"]}><Dashboard /></RoleRoute> },
            { path: 'gelen-basvurular', loader : useAuth, element: <RoleRoute roles={["Danışman"]}><Basvurular /></RoleRoute> },

            { path: 'donem', loader : useAuth, element: <RoleRoute roles={["Yönetici"]}><Dashboard /></RoleRoute> },
            { path: 'tanimlar', loader : useAuth, element: <RoleRoute roles={["Yönetici"]}><Tanimlar /></RoleRoute> },
            { path: 'donem-islemleri', loader : useAuth, element: <RoleRoute roles={["Yönetici"]}><DonemIslemleri /></RoleRoute> },
            { path: 'ogrenci-listesi', loader : useAuth, element: <RoleRoute roles={["Yönetici"]}><OgrenciListesi /></RoleRoute> },
            { path: 'danisman-tanimlari', loader : useAuth, element: <RoleRoute roles={["Yönetici"]}><DanismanTanimlari /></RoleRoute> },
            { path: 'tum-basvurular', loader : useAuth, element: <RoleRoute roles={["Yönetici"]}><TumBasvurular /></RoleRoute> },
            { path: 'sistem-ayarlari', loader : useAuth, element: <RoleRoute roles={["Yönetici"]}><SistemAyarlari /></RoleRoute> },

            { path: 'ogrenci-hesap', loader : useAuth, element: <RoleRoute roles={["Öğrenci"]}><OgrenciHesap /></RoleRoute> },
            { path: 'yeni-basvuru', loader : useAuth, element: <RoleRoute roles={["Öğrenci"]}><YeniBasvuru /></RoleRoute> },
            { path: 'seminer-print/:code', loader : useAuth, element: <RoleRoute roles={["Yönetici","Öğrenci","Danışman"]}><SeminerPrint /></RoleRoute> },
            { path: 'ogrenci-basvurular', loader : useAuth, element: <RoleRoute roles={["Öğrenci"]}><OgrenciBasvurular /></RoleRoute> },
        ],
    },
    {
        path: '*',
        element: <ErrorLayout />,
        children: [{ path: '*', element: <Page404 /> }],
    },
])




export default router
